import { createStyles, makeStyles } from '@material-ui/core'
import { memo } from 'react'

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      height: 40,
      '& img': {
        width: 'auto',
        height: '50%',
        margin: theme.spacing(0, 2)
      }
    }
  })
)

export const bankLogos = {
  bankOfScotland: 46, // Prio
  barclaycard: 7, // Prio
  ingDiba: 55, // Prio
  postbank: 26, // Prio
  santanderCar: 32, // Prio
  targobank: 34, // Prio
  ofina: 51, // Prio
  skp: 67,
  '1822direkt': 61,
  auxmoney: 2,
  creditPlus: 49,
  degussa: 56,
  deutscheBank: 17,
  dkb: 19,
  dslBank: 16,
  norisbank: 24,
  oyakAnkerBank: 25,
  qlick: 57,
  santanderBestCredit: 53,
  sberbankEuropaAg: 40,
  skg: 29,
  swk: 59,
  commerzbank: 63
}

const cdnUrl = 'https://cdn.finanzcheck.de/products/builtin/#id.svg'

const BANK_ROWS = [
  ['auxmoney', 'dslBank', 'norisbank', 'creditPlus'],
  ['santanderBestCredit', 'bankOfScotland', 'barclaycard', 'swk'],
  ['targobank', 'ingDiba', 'postbank', 'qlick'],
  ['skg', 'ofina', 'santanderCar', 'dkb'],
  ['1822direkt', 'deutscheBank', 'degussa', 'oyakAnkerBank']
]

interface LogoProps {
  logoId: string
  bankName: string
}

export const Logo = ({ logoId, bankName }: LogoProps) => (
  <img
    src={cdnUrl.replace('#id', logoId.toString())}
    alt={`logo-${bankName}`}
  />
)

interface LogoRowProps {
  rowId: number
  bankNames: string[]
}

const LogoRow = ({ bankNames, rowId }: LogoRowProps) => {
  const { container } = useStyles()

  return (
    <div className={container}>
      {bankNames.map((bankName, index) => (
        <Logo
          // eslint-disable-next-line react/no-array-index-key
          key={`logo-${rowId}-${bankName}-${index}`}
          logoId={bankLogos[bankName]}
          bankName={bankName}
        />
      ))}
    </div>
  )
}

interface LogoBoardProps {
  boardId: number
}

const LogoBoard = ({ boardId }: LogoBoardProps) => (
  <>
    {BANK_ROWS.map((bankNames, index) => (
      <LogoRow
        // eslint-disable-next-line react/no-array-index-key
        key={`logo-${boardId}-row-${index}`}
        rowId={index}
        bankNames={bankNames}
      />
    ))}
  </>
)

export default memo(LogoBoard)
